import { Banner } from 'model';
import { createAsyncAction } from 'typesafe-actions';

export const getActiveBannerItems = createAsyncAction(
  'activeBanner/GET_ACTIVEBANNER_ITEMS_REQUEST',
  'activeBanner/GET_ACTIVEBANNER_ITEMS_SUCCESS',
  'activeBanner/GET_ACTIVEBANNER_ITEMS_FAILURE',
)<undefined, Banner, undefined>();
